import {toPlainText} from 'next-sanity';

import {imageWebFromImageWebSchema} from '@/modules/foundation/sanity/image/query';
import {internalLinkToHref} from '@/modules/foundation/sanity/link/query';
import type {ArticleBySlugQueryResult} from '@/sanity/schemas/types';

import type {ArticleDetails} from '../shared/types';

import {DOCUMENT_TYPE_ARTICLE} from './constants';

export const ARTICLE_IN_CARD_FRAGMENT = `//groq
	_id,
	title,
	slug,
	_createdAt,
	image,
	lead,
	publishDate,
	"areas": areas[]->title,
	"fieldOfAreas": fieldOfAreas[]->title
`;

export type ArticleInCardFragment = NonNullable<
	NonNullable<ArticleBySlugQueryResult>['latestArticles'][number]
>;

export function articleInCardFragmentToArticleDetails(
	article: ArticleInCardFragment,
): ArticleDetails {
	const badges: string[] = [];

	if (article.fieldOfAreas) {
		for (const fieldOfArea of article.fieldOfAreas) {
			if (fieldOfArea) {
				badges.push(fieldOfArea);
			}
		}
	}

	if (article.areas) {
		for (const area of article.areas) {
			if (area) {
				badges.push(area);
			}
		}
	}

	return {
		title: article.title ?? '',
		createdAt: article.publishDate ?? article._createdAt ?? '',
		href: internalLinkToHref(DOCUMENT_TYPE_ARTICLE, article.slug?.current),
		imageWeb: article?.image?.asset?._ref
			? imageWebFromImageWebSchema(article.image, 420 / 245)
			: undefined,
		description: article.lead && article.lead.length > 0 ? toPlainText(article.lead) : '',
		badges,
	};
}
